<router-outlet></router-outlet>
<p-toast position="bottom-center" key="br">
    <ng-template let-message pTemplate="message">
        <div class="p-toast-message-content">
            <div class="p-toast-message-text">
                <span class="p-toast-summary" *ngIf="message.summary">{{message.summary}}</span>
                <div class="p-toast-detail">
                    <ng-container *ngIf="message.data?.showFileCenter; else normalMessage">
                        <span>{{translation.instant('TOAST.EXPORT.COMPLETED.BEFORE')}}</span><span 
                            class="file-center-link"
                            (click)="navigateToFileCenter()">{{translation.instant('TOAST.EXPORT.COMPLETED.LINK')}}</span><span>{{translation.instant('TOAST.EXPORT.COMPLETED.AFTER')}}</span>
                    </ng-container>
                    <ng-template #normalMessage>
                        {{message.detail}}
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
